import IAbility from "@/libs/acl/interfaces/IAbility";

export const initialAbility: Array<IAbility> = [
  {
    action: "read",
    subject: "",
  },
];
